<template>
  <div class="container-fluid mt-2">
    <div role="toolbar" class="btn-toolbar">
      <div class="btn-group mr-3 mb-3">
        <button @click="save()" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button>
        <button @click="test()" class="btn btn-secondary"><font-awesome-icon icon="vial"/>&nbsp;Testlauf</button>
      </div>
      <div class="input-group">
        <input type="text" v-model="customerid" class="form-control" placeholder="Kunden-Nr."/>
      </div>
      <div class="input-group mb-3 ml-3">
        <div class="input-group-prepend">
          <div class="input-group-text">
            <input type="checkbox" v-model="config['locations.customer.active']" true-value="1" false-value="0">
          </div>
        </div>
        <input type="text" class="form-control" value="Aktiviert" disabled>
      </div>
    </div>
    <div class="container-fluid mt-2" style="height:600px;">
      <div class="row">
        <div class="col-md">
          <AceEditor ref="geoeditor" :editorId='"geoeditor"' lang="javascript" :content="config['locations.customer.service']"/>
        </div>
        <div class="col-md">
          <iframe style="width:100%;height:500px;border: none;" :src="baseurl + 'help/geocoding.html'">
          </iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/modules/config.js'
import AceEditor from '@/components/AceEditor.vue'

export default {
  name: 'GeoCodingRule',
  components: {
    AceEditor
  },
  data() {
    return {
      needs: ["locations.customer.service","locations.customer.active"],
      config: {},
      customerid: "",
      baseurl: config.baseUrl
    }
  },
  mounted: function() {
    var self = this;
    config.loadcfg(this.needs,this,function(data) {
      self.config = data;
    })
  },
  methods: {
    test: function() {
      console.log('test geocode');
      var cid  = this.customerid;
      var self = this;
      config.get(this,config.baseUrl + 'rest/config/checkgeo?cid=' + encodeURIComponent(cid),'Geo Code Testlauf',function(data) {
          self.$bvToast.toast('Testergebnis: Long: ' + data.geolong + '\nLat: ' + data.geolat,{title: 'GeoPosition',variant: 'success'});
      });
    },
    save: function() {
      console.log(JSON.stringify(this.config));
      var self = this;
      this.config["locations.customer.service"] = this.$refs.geoeditor.getContent();
      config.savecfg(this.config,this,function() {
        self.$bvToast.toast('Konfiguration gespeichert',{title:'Geo Coding',variant: 'success'});
      })
    }
  }
}
</script>
